import React from 'react';
import { opening } from '../../../data/pulse';
export function OpeningScreen() {
  return <div className="flex flex-1 flex-col justify-center" data-id="element-216" data-mp="33vlb9rizh36y">
      <p className="text-[9.5px] uppercase tracking-micro text-blue" data-id="element-217" data-mp="33y7ghkiej6m0">{opening.eyebrow}</p>

      <h2 className="mt-4 font-display text-[30px] font-semibold leading-[1.04] tracking-tight text-navy" data-id="element-218" data-mp="2yx9z3a57uglk">
        {opening.headline}
      </h2>

      <p className="mt-4 text-[13px] leading-relaxed text-mut" data-id="element-219" data-mp="3rm762h3z8qz0">{opening.support}</p>

      <p className="mt-6 border-t border-line pt-5 font-display text-[17px] font-semibold leading-snug text-navy2" data-id="element-220" data-mp="3mmm56158y8jn">
        {opening.prompt}
      </p>

      <p className="mt-3 text-[12.5px] leading-relaxed text-mut" data-id="element-221" data-mp="3hub7l4xzayu9">{opening.promise}</p>

      <p className="mt-auto pt-6 text-[9px] leading-snug text-mut" data-id="element-222" data-mp="3cvrgyr8fwyvk">{opening.footnote}</p>
    </div>;
}